// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SeriesCategoryVO')
export class SeriesCategoryVO {

  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('order', 'Number')
  public order: number = undefined;

  @JsonProperty('displayName', 'String')
  public displayName: string = undefined;

  @JsonProperty('locale', 'String')
  public locale: string = undefined;
}
